/* eslint-disable no-unused-vars */
import { observable, action, makeObservable, runInAction } from 'mobx';
import {
    getChapterList,
    getProcess,
    getScoreDetail,
    getTipInfo,
    getOpenChapterList,
    getCompositeDetail,
    getPlanTree,
    projectScoreDetail,
    projectScoreRule,
    getCertificate,
    getCertificateImage
} from '@/api/teachingBusiness';
import ToastUtils from '../utils/ToastUtils';
import _ from 'lodash';
import { getCourseDetail } from '@/api/openCourse';
import { convertTree, sortTreeData } from '@/utils/convertTree';
class teachBusiness {
    constructor() {
        makeObservable(this);
    }

    @observable
    loading = true;

    @action
    setLoading = (v) => {
        this.loading = v;
    };

    @observable
    focusRefreshFlag = true; //true：在重新获取焦点时刷新接口，false：在重新获取焦点时不刷新接口

    @action
    setFocusRefreshFlag = (v) => {
        this.focusRefreshFlag = v;
    };
    @observable state = {
        planId: '',
        params: {
            template_id: 0,
            business_id: 0
        },
        chapterList: [],
        chapterOpenList: [],
        processInfo: {},
        scoreDetail: {},
        tipInfo: [],
        courseDetail: {},
        projectDetail: {}
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };

    @observable
    isVisible = false;

    @action
    setIsVisible = (v) => {
        this.isVisible = v;
    };

    @observable
    descListData = {};

    @action
    setDescListData = (v) => {
        this.descListData = v;
    }; //点击考核说明里面的跳转

    @observable
    chapterList = [];

    @action
    setChapterList = (v) => {
        this.chapterList = v;
    };
    //获取章节列表
    getChapterList = async () => {
        const { code, msg, data } = await getChapterList({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id
        });

        if (code === '00000') {
            const newData = convertTree(sortTreeData(data));

            this.setState({
                chapterList: newData
            });
            return true;
        }
        this.setState({
            chapterList: []
        });
        ToastUtils.showAbnormalToast(msg);
        return false;
    };

    //公开接口
    getOpenChapterList = async () => {
        const { code, msg, data } = await getOpenChapterList({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id
        });

        if (code === '00000') {
            const newData = convertTree(sortTreeData(data));

            this.setState({
                chapterOpenList: newData
            });
            return true;
        }
        this.setState({
            chapterOpenList: []
        });
        ToastUtils.showAbnormalToast(msg);
        return false;
    };
    //获取考核信息
    getProcess = async () => {
        const { code, msg, data } = await getProcess({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id
        });

        if (code === '00000') {
            this.setState({
                processInfo: data
            });
        } else {
            this.setState({
                processInfo: {}
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };
    getCourseDetail = async () => {
        const { code, msg, data } = await getCourseDetail(this.state.params.business_id, { template_id: this.state.params.template_id });

        if (code === '00000') {
            this.setState({
                courseDetail: data,
                planId: data.plan_id
            });
        } else {
            this.setState({
                courseDetail: {}
            });
            ToastUtils.showAbnormalToast(msg);
        }
        return data;
    };
    //获取得分详情
    getScoreDetail = async () => {
        const { code, msg, data } = await getScoreDetail({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id
        });

        if (code === '00000') {
            this.setState({
                scoreDetail: data
            });
        } else {
            this.setState({
                scoreDetail: {}
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    getTipInfo = async () => {
        const { code, msg, data } = await getTipInfo({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id
        });

        if (code === '00000') {
            this.setState({
                tipInfo: data
            });
        } else {
            this.setState({
                tipInfo: []
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    //项目接口 - start
    //没用到
    // @observable projectDetail = {};

    // 是否显示了问卷弹窗
    @observable isShowDialogUtils = false;
    @action
    setIsShowDialogUtils = (v) => {
        this.isShowDialogUtils = v;
    };

    //教学详情
    getCompositeDetail = async () => {
        const { code, msg, data } = await getCompositeDetail({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id
        });
        if (code === '00000') {
            this.setState({
                projectDetail: data,
                planId: data?.plan_id
            });
        } else {
            this.setState({
                projectDetail: {}
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    //问卷弹窗
    @observable questionModalVisible = false;
    //当前问卷index
    @observable currentQuestionnaireIndex = -1;
    //问卷索引数组
    @observable requiredQuestionnaireIndices = [];

    getCompositeDetailModal = async (params) => {
        const { code, msg, data } = await getCompositeDetail(params);
        if (code === '00000') {
            runInAction(() => {
                this.requiredQuestionnaireIndices = [];
                for (let i = 0; i < data.questionnaire_list?.length; i++) {
                    const item = data.questionnaire_list[i];
                    //required  1必答 2非必答
                    //pop_number 弹出次数 1未作答则反复弹出 2弹出一次 3不弹出
                    //pop_status  弹出状态 1 弹出一次
                    if (
                        item?.required === 1 ||
                        (item?.required === 2 && item?.pop_number === 1) ||
                        (item?.required === 2 && item?.pop_number === 2 && item?.pop_status !== 1)
                    ) {
                        this.requiredQuestionnaireIndices.push(i);
                    }
                }
                if (this.requiredQuestionnaireIndices.length > 0) {
                    this.currentQuestionnaireIndex = this.requiredQuestionnaireIndices[0];
                    this.questionModalVisible = true;
                    this.setState({
                        projectDetail: data,
                        planId: data?.plan_id
                    });
                }
            });
        } else {
            runInAction(() => {
                this.requiredQuestionnaireIndices = [];
                this.currentQuestionnaireIndex = -1;
                this.questionModalVisible = false;
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    //显示下一个问卷弹窗
    @action
    showNextQuestionnaire = () => {
        if (!this.requiredQuestionnaireIndices.length) return;
        const currentPosition = this.requiredQuestionnaireIndices.indexOf(this.currentQuestionnaireIndex);
        if (currentPosition < this.requiredQuestionnaireIndices.length - 1) {
            this.currentQuestionnaireIndex = this.requiredQuestionnaireIndices[currentPosition + 1];
            this.questionModalVisible = true;
        } else {
            this.requiredQuestionnaireIndices = [];
            this.currentQuestionnaireIndex = -1;
            this.questionModalVisible = false;
        }
    };

    @action
    setQuestionModalVisible = (v, isFinish = false) => {
        this.questionModalVisible = v;
        if (isFinish) return;
        if (!v) {
            setTimeout(() => {
                this.showNextQuestionnaire();
            }, 300);
        }
    };

    // //教学内容树
    @observable planList = [];

    @observable includeChuang = false;

    // 项目考核项 展开参数
    @observable activeProjectSections = [];
    // 阶段
    @observable teachSectionCount = 0;
    // 教学活动
    @observable teachActiveCount = 0;
    @action
    setActiveProjectSections = (v) => {
        this.activeProjectSections = v;
    };

    getPlanTree = async () => {
        let { projectDetail } = this.state;
        if (!projectDetail.plan_id || !projectDetail.version || !projectDetail.learning_method || !projectDetail.template_id) {
            return;
        }
        const { code, msg, data } = await getPlanTree({
            template_id: projectDetail.template_id,
            plan_id: projectDetail.plan_id,
            business_id: this.state.params.business_id,
            version: projectDetail.version,
            learning_method: projectDetail.learning_method
        });

        if (code === '00000') {
            runInAction(() => {
                this.planList = data;
                this.teachActiveCount = 0;
                let activeProjectSections = [];
                if (this.planList.length && this.planList[0].node_type === 1) {
                    this.planList.forEach((i, index) => {
                        this.teachSectionCount = this.planList.length;
                        activeProjectSections.push(index);
                        if (i?.data?.learning_method === 2) {
                            this.includeChuang = true;
                        }
                        if (i?.sub_nodes) {
                            this.teachActiveCount += i.sub_nodes.length;
                        }
                    });
                } else {
                    this.includeChuang = false;
                    this.teachSectionCount = 0;
                    this.teachActiveCount = this.planList.length;
                }
                this.activeProjectSections = activeProjectSections;
            });
        } else {
            runInAction(() => {
                this.planList = [];
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    @observable containTitleNum = 0;

    @action
    getProjectScoreSortList = () => {
        const list = this.projectScoreList;
        if (list.length) {
            if (list[0].node_type === 1) {
                if (list[0].sub_nodes.length > 2) {
                    this.containTitleNum = 1;
                } else {
                    this.containTitleNum = 2;
                }
            } else {
                this.containTitleNum = 0;
            }
        }
    };

    //成绩
    @observable projectScoreList = [];
    // 总成绩
    @observable totalScore = 0;
    // 总学时
    @observable totalHour = 0;
    // 总学时
    @observable assessmentMethod = 0;

    getProjectScoreList = async () => {
        const { code, msg, data } = await projectScoreDetail({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id,
            plan_id: this.state.planId
        });

        if (code === '00000') {
            runInAction(() => {
                this.projectScoreList = data?.plan_trees;
                this.totalScore = data?.total_score;
                this.totalHour = data?.total_hour;
                this.assessmentMethod = data?.assessment_method;

                this.getProjectScoreSortList();
            });
        } else {
            runInAction(() => {
                this.projectScoreList = [];
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    //成绩规则
    @observable projectRule = {};

    getProjectRule = async () => {
        const { code, msg, data } = await projectScoreRule({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id,
            plan_id: this.state.planId
        });

        if (code === '00000') {
            runInAction(() => {
                this.projectRule = data;
            });
        } else {
            runInAction(() => {
                this.projectRule = [];
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    @observable certificateInfo = {
        enabled: true,
        obj_name: true,
        imageUrl: ''
    };

    @observable planId = '';

    @action
    setPlanId = (v) => {
        this.planId = v;
    };

    @observable certifLoading = true;
    // getCourseCertificate = async () => {
    //     const { code, msg, data } = await getCertificate({
    //         business_id: this.business_id,
    //         template_id: this.template_id,
    //         // plan_id: this.projectDetail.plan_id
    //         plan_id: this.planId
    //     });
    //
    //     if (code === '00000') {
    //         runInAction(() => {
    //             this.certificateInfo = data;
    //         });
    //         if (data?.obj_name) {
    //             await this.getCertificateImage();
    //         }
    //     } else {
    //         runInAction(() => {
    //             this.certificateInfo = {};
    //         });
    //         ToastUtils.showAbnormalToast(msg);
    //     }
    // };

    getCertificate = async () => {
        const { code, msg, data } = await getCertificate({
            business_id: this.state.params.business_id,
            template_id: this.state.params.template_id
            // plan_id: this.state.planId
        });

        if (code === '00000') {
            runInAction(() => {
                this.certificateInfo = data;
                this.certifLoading = false;
            });
            if (data?.obj_name) {
                await this.getCertificateImage();
            }
        } else {
            runInAction(() => {
                this.certificateInfo = {};
                this.certifLoading = false;
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    getCertificateImage = async () => {
        const { success, data, msg } = await getCertificateImage(this.state.planId, {
            objName: this.certificateInfo.obj_name
        });

        if (success) {
            runInAction(() => {
                this.certificateInfo.imageUrl = data.url;
            });
        } else {
            runInAction(() => {
                this.certificateInfo.imageUrl = '';
            });
            ToastUtils.showAbnormalToast(msg);
        }
    };

    //项目接口 - end

    @action
    clear = () => {
        this.loading = false;
        this.chapterList = [];
        this.processInfo = {};
        this.scoreDetail = {};
        this.tipInfo = [];
        // this.projectDetail = {};
        this.planList = [];
        this.projectScoreList = [];
        this.projectRule = {};
        this.certificateInfo = {};
    };
}
export default new teachBusiness();
